<h4 class="card-title">User Management</h4>
<p *ngIf="!isLoading && pageData.viewMode=='LIST'">
  {{pageData.userList.length}} user(s) in total.
</p>
<div *ngIf="isLoading">
  <div class="preloader-wrapper big active">
    <div class="spinner-layer spinner-blue-only">
      <div class="circle-clipper left">
        <div class="circle"></div>
      </div><div class="gap-patch">
        <div class="circle"></div>
      </div><div class="circle-clipper right">
        <div class="circle"></div>
      </div>
    </div>
  </div>
</div>
<div *ngIf="!isLoading">
<div *ngIf="pageData.viewMode=='LIST'" class="row">
  <ng-container *ngFor="let rec of pageData.userList; let i = index;" >
  <div *ngIf="rec.role != 'GEEK' && rec.role != 'SA'" class="col s12 m6 l4 card-width">
    <div class="card card-border center-align gradient-45deg-purple-deep-orange">
      <div class="card-content white-text">
        <div class="col s12"><i class="material-icons right hide">favorite</i></div>
        <img class="responsive-img circle z-depth-4" width="100" src="./assets/img/logo/profile.logo2.png" alt="">
        <h5 class="white-text mb-1">{{rec.fullName}}</h5>
        <p class="m-0">{{rec.email}}</p>
        <p class="mt-8">
          {{rec.role}}<br/>
          Last Login at {{rec.param1}}<br/>
          Created on 02 May 2019.
        </p>
        <!-- <a class="waves-effect waves-light btn gradient-45deg-green-teal border-round mt-7 z-depth-4">HireMe</a> -->
        <div class="row mt-5">
          <a (click)="userForm(rec)" href="javascript:void(0);" class="col s4">
            <h5 class="gradient-45deg-indigo-light-blue icon-background circle white-text z-depth-3">
              <i class="material-icons">edit</i>
            </h5>
          </a>
          <a (click)="userDelete(rec)" href="javascript:void(0);" class="col s4">
            <h5 class="icon-background circle gradient-45deg-red-pink white-text z-depth-3">
              <i class="material-icons">delete</i>
            </h5>
          </a>
          <a href="#" class="col s4 hide">
            <h5 class="icon-background circle gradient-45deg-red-pink white-text z-depth-3">
              <svg class="svg-inline--fa fa-pinterest-p fa-w-12" aria-hidden="true" data-prefix="fab" data-icon="pinterest-p" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" data-fa-i2svg=""><path fill="currentColor" d="M204 6.5C101.4 6.5 0 74.9 0 185.6 0 256 39.6 296 63.6 296c9.9 0 15.6-27.6 15.6-35.4 0-9.3-23.7-29.1-23.7-67.8 0-80.4 61.2-137.4 140.4-137.4 68.1 0 118.5 38.7 118.5 109.8 0 53.1-21.3 152.7-90.3 152.7-24.9 0-46.2-18-46.2-43.8 0-37.8 26.4-74.4 26.4-113.4 0-66.2-93.9-54.2-93.9 25.8 0 16.8 2.1 35.4 9.6 50.7-13.8 59.4-42 147.9-42 209.1 0 18.9 2.7 37.5 4.5 56.4 3.4 3.8 1.7 3.4 6.9 1.5 50.4-69 48.6-82.5 71.4-172.8 12.3 23.4 44.1 36 69.3 36 106.2 0 153.9-103.5 153.9-196.8C384 71.3 298.2 6.5 204 6.5z"></path></svg><!-- <i class="fab fa-pinterest-p"></i> -->
            </h5>
            <p class="white-text">Delete</p>
          </a>
        </div>
      </div>
    </div>
  </div>
  </ng-container>
</div>
<div *ngIf="pageData.viewMode=='FORM'">
  <form class="col s12">
    <div class="row">
      <div class="input-field col s12">
        <i class="material-icons prefix">account_circle</i>
        <input [(ngModel)]="pageData.account.fullName" id="txtName" name="txtName" type="text" />
        <label for="txtName" class="active">Name</label>
      </div>
    </div>
    <div class="row">
      <div class="input-field col s12">
        <i class="material-icons prefix">email</i>
        <input [(ngModel)]="pageData.account.email" id="txtEmail" name="txtEmail" type="email" [disabled]="pageData.actionMode == 'EDIT'" />
        <label for="txtEmail" class="active">Email</label>
      </div>
    </div>
    <!-- <div class="row">
      <div class="input-field col s12">
        <i class="material-icons prefix">T</i>
        <input [(ngModel)]="pageData.account.title" id="txtTitle" name="txtTitle" type="text" />
        <label for="txtTitle" class="active">Title</label>
      </div>
    </div> -->
    <div class="row" [hidden]="pageData.actionMode == 'EDIT'">
      <div class="input-field col s12">
        <i class="material-icons prefix">lock_outline</i>
        <input [(ngModel)]="pageData.account.password" id="txtPassword" name="txtPassword" type="password" />
        <label for="txtPassword" class="active">Password</label>
      </div>
    </div>
    <div class="row" [hidden]="pageData.actionMode == 'EDIT'">
      <div class="input-field col s12">
        <i class="material-icons prefix">lock_outline</i>
        <input [(ngModel)]="pageData.account.confirmPassword" id="txtConfirmPassword" name="txtConfirmPassword" type="password" />
        <label for="txtConfirmPassword" class="active">Confirm Password</label>
      </div>
    </div>
    <div class="row">
      <div class="col s12">
        <i class="material-icons prefix">fingerprint</i>
        <a class='dropdown-trigger btn waves-effect waves-light btn gradient-45deg-green-teal z-depth-4 mr-1 mb-2' href='#' data-target='ddl_user_roles' style="min-width:150px; margin-left: 22px;">
          <i class="material-icons right" style="opacity:0.7;">keyboard_arrow_down</i>
          <span *ngIf="roleSelected">{{roleSelected.title}}</span>
        </a>
        <!-- Dropdown Structure -->
        <ul id='ddl_user_roles' class='dropdown-content'>
          <li (click)="roleSelect(rec)" *ngFor="let rec of roles; let iRec = index;">
            <a href="javascript:void(0);" class="li_area">{{rec.value}}</a>
          </li>
        </ul>
      </div>
    </div>
    <div class="row" *ngIf="oAcc && oAcc.role=='SA' && pageData.actionMode=='EDIT'">
      <div class="col s12">
        <!-- <i class="material-icons prefix">markunread_mailbox</i> -->
        <label>
           <input type="checkbox" [(ngModel)]="tAccount.alertDailyCountEmail" name="chkAlertDailyCountEmail" />
           <span>Daily Count Email Alert</span>
        </label>
      </div>
    </div>
    <!-- <div class="row">
      <div class="input-field col s12">
        <i class="material-icons prefix">contact_phone</i>
        <input [(ngModel)]="pageData.account.contactNo" id="txtContactNo" name="txtContactNo" type="tel" />
        <label for="txtContactNo" class="active">Contact Number</label>
      </div>
    </div> -->
    <div class="row">
      <!-- <div class="input-field col s12">
        <i class="material-icons prefix">question_answer</i>
        <textarea id="message3" class="materialize-textarea"></textarea>
        <label for="message3">Message</label>
      </div> -->
      <div class="row">
        <div class="input-field col s12">
          <button (click)="onSubmit()" class="btn cyan waves-effect waves-light right" type="submit" name="action">Submit
            <i class="material-icons right">send</i>
          </button>
          <button (click)="userList()" class="btn cyan lighten-2 waves-effect waves-light right" type="submit" name="action" style="margin-right: 2px;">Cancel
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
<div *ngIf="pageData.viewMode=='LIST'" style="bottom: 50px; right: 19px;" class="fixed-action-btn direction-top">
  <a (click)="userForm(null)" class="btn-floating btn-large gradient-45deg-deep-purple-blue gradient-shadow"><i class="material-icons">add</i></a>
  <ul>
      <li><a href="css-helpers.html" class="btn-floating blue"><i class="material-icons">help_outline</i></a></li>
      <li><a href="cards-extended.html" class="btn-floating green"><i class="material-icons">widgets</i></a></li>
      <li><a href="app-calendar.html" class="btn-floating amber"><i class="material-icons">today</i></a></li>
      <li><a href="app-email.html" class="btn-floating red"><i class="material-icons">mail_outline</i></a></li>
  </ul>
</div>
</div>
